export enum worldEnum {
  Main = 0,
  Cellular = 1,
  Abroad = 2,
  Internet = 3,
  TV = 4,
  Energy = 5,
}
export enum TAB_ENUM {
  Main = 'Main',
  Cellular = 'Cellular',
  Abroad = 'Abroad',
  Internet = 'Internet',
  TV = 'TV',
  Energy = 'Energy',
}
export enum internalPage {
  Main = 0,
  EditPersonalInfo = 1,
  ServiceDetailsPage = 2,
  FullFinancedErrorPage = 3,
}
export enum productType {
  Cellular = 'Cellular',
  Abroad = 'Abroad',
  Internet = 'Internet',
  InternetIsp = 'InternetIsp',
  InternetInfra = 'InternetInfra',
  Mapa = 'Mapa',
  TV = 'TV',
  Energy = 'Energy',
}

export const ActiveStatus = ['Active', 'A', 'INS'];

export function getProductStatus(subscriber) {
  if (subscriber.isBusinness) {
    return 'עסקי';
  } else {
    if (!ActiveStatus.includes(subscriber.productStatus)) {
      return subscriber.productStatusDesc;
    }
  }
  return;
}
